<template>
  <svg
    width="17"
    height="27"
    viewBox="0 0 17 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.68073 20.3714L5.08362 16.6613C4.4341 15.7334 5.09791 14.4584 6.23054 14.4584L10.7694 14.4584C11.902 14.4584 12.5658 15.7334 11.9163 16.6613L9.31919 20.3714C8.92109 20.9401 8.07883 20.9401 7.68073 20.3714Z"
      fill="#C5C5C5"
      class="sort-down"
    />
    <path
      d="M9.31927 6.12858L11.9164 9.83874C12.5659 10.7666 11.9021 12.0416 10.7695 12.0416L6.23063 12.0416C5.09799 12.0416 4.43418 10.7666 5.0837 9.83874L7.68081 6.12858C8.07891 5.55987 8.92117 5.55987 9.31927 6.12858Z"
      fill="#C5C5C5"
      class="sort-up"
    />
  </svg>
</template>

<style lang="scss">
.v-data-table__th--sorted {
  .asc {
    .sort-up {
      fill: #df252a;
    }
  }
}

.v-data-table__th--sorted {
  .desc {
    .sort-down {
      fill: #df252a;
    }
  }
}
</style>
